module.exports = {
  multiHosCertifyDaysCount: 180,
  multiHosCertifyOffDutyDaysCount: 7,
  hosRangeFilterDefault: 7,
  fetchCalendarDotsLogsCount: 220,
};
